"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapLabelValueToListItem = exports.mapLabelValuesToDescriptions = exports.deleteLabelValue = exports.updateLabelValue = exports.createLabelValue = exports.getLabelValues = exports.getLabelValuesForInitalState = exports.CUSTOM_LABEL_VALUE_LIST_ITEM_TEST_ID = exports.CERTIFICATION_LABEL_DIALOG_TYPE_TEST_ID = exports.SENSITIVITY_LABEL_DIALOG_TYPE_TEST_ID = exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const LabelType_1 = require("../shared/LabelType");
exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID = 'data-quality-dialog-type';
exports.SENSITIVITY_LABEL_DIALOG_TYPE_TEST_ID = 'sensitivity-label-dialog-type';
exports.CERTIFICATION_LABEL_DIALOG_TYPE_TEST_ID = 'certification-label-dialog-type';
exports.CUSTOM_LABEL_VALUE_LIST_ITEM_TEST_ID = 'custom-label-value-list-item';
const partialConfig = {
    restApiVersion: 'exp',
    serverWideRequest: false,
};
function getLabelValuesForInitalState(params) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { transform } = params;
        const data = yield getLabelValues(params);
        const labels = (0, vizportalclient_common_components_1.groupByToMultimap)({
            data,
            keyTransform: (original) => ({ labelValueName: original.name.toLowerCase(), category: original.category.toLowerCase() }),
            valTransform: transform,
            keyBy: ({ labelValueName, category }) => `${category}-${labelValueName}`,
        });
        return labels;
    });
}
exports.getLabelValuesForInitalState = getLabelValuesForInitalState;
function getLabelValues({ makeJsonRestApiRequest, category }) {
    var _a, _b;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const endpoint = category ? `labelValues/?categories=${category}` : 'labelValues';
        const data = yield makeJsonRestApiRequest(Object.assign(Object.assign({}, partialConfig), { restApiVersion: '3.20', endpoint, httpMethod: 'GET' }));
        const labelValues = (_b = (_a = data === null || data === void 0 ? void 0 : data.labelValueList) === null || _a === void 0 ? void 0 : _a.labelValue) !== null && _b !== void 0 ? _b : [];
        return labelValues;
    });
}
exports.getLabelValues = getLabelValues;
function createLabelValue({ makeJsonRestApiRequest, labelValue }) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const data = yield makeJsonRestApiRequest(Object.assign(Object.assign({}, partialConfig), { endpoint: 'labelValues', httpMethod: 'PUT' }), { labelValue });
        return Object.assign({}, data.labelValue);
    });
}
exports.createLabelValue = createLabelValue;
function updateLabelValue({ makeJsonRestApiRequest, labelValue, name }) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const data = yield makeJsonRestApiRequest(Object.assign(Object.assign({}, partialConfig), { endpoint: `labelValues/${name}`, httpMethod: 'PUT' }), { labelValue });
        return Object.assign({}, data.labelValue);
    });
}
exports.updateLabelValue = updateLabelValue;
function deleteLabelValue({ makeJsonRestApiRequest }, name) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const result = yield makeJsonRestApiRequest(Object.assign(Object.assign({}, partialConfig), { endpoint: `labelValues/${name}`, httpMethod: 'DELETE' }));
        return result;
    });
}
exports.deleteLabelValue = deleteLabelValue;
/** @deprecated */
function mapLabelValuesToDescriptions(labelValues) {
    return labelValues.reduce((mapping, labelValue) => {
        mapping.set(labelValue.name, labelValue.description);
        return mapping;
    }, new Map());
}
exports.mapLabelValuesToDescriptions = mapLabelValuesToDescriptions;
function mapLabelValueToListItem(type) {
    switch (type.name) {
        case 'SENSITIVE_DATA':
            return labelTypeListItem(LabelType_1.LabelType.SENSITIVE_DATA);
        case 'DEPRECATED':
            return labelTypeListItem(LabelType_1.LabelType.DEPRECATED);
        case 'STALE':
            return labelTypeListItem(LabelType_1.LabelType.STALE);
        case 'WARNING':
            return labelTypeListItem(LabelType_1.LabelType.WARNING);
        case 'MAINTENANCE':
            return labelTypeListItem(LabelType_1.LabelType.MAINTENANCE);
        case 'EXTRACT_REFRESH_FAILURE':
            return labelTypeListItem(LabelType_1.LabelType.EXTRACT_REFRESH_FAILURE);
        case 'FLOW_RUN_FAILURE':
            return labelTypeListItem(LabelType_1.LabelType.FLOW_RUN_FAILURE);
        case 'CERTIFIED':
            return labelTypeListItem(LabelType_1.LabelType.CERTIFIED);
        default:
            return {
                content: type.name,
                value: type.name,
                testId: exports.CUSTOM_LABEL_VALUE_LIST_ITEM_TEST_ID + '-' + type.name,
            };
    }
}
exports.mapLabelValueToListItem = mapLabelValueToListItem;
function getLabelTestId(type) {
    switch (type) {
        case LabelType_1.LabelType.SENSITIVE_DATA:
            return exports.SENSITIVITY_LABEL_DIALOG_TYPE_TEST_ID;
        case LabelType_1.LabelType.CERTIFIED:
            return exports.CERTIFICATION_LABEL_DIALOG_TYPE_TEST_ID;
        case LabelType_1.LabelType.WARNING:
            return exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID;
        case LabelType_1.LabelType.DEPRECATED:
            return exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID;
        case LabelType_1.LabelType.STALE:
            return exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID;
        case LabelType_1.LabelType.MAINTENANCE:
            return exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID;
        case LabelType_1.LabelType.EXTRACT_REFRESH_FAILURE:
            return exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID;
        case LabelType_1.LabelType.FLOW_RUN_FAILURE:
            return exports.DATA_QUALITY_DIALOG_TYPE_TEST_ID;
        case LabelType_1.LabelType.CUSTOM_LABEL_VALUE:
            return exports.CUSTOM_LABEL_VALUE_LIST_ITEM_TEST_ID;
        default:
            (0, vizportalclient_common_components_1.assertUnreachable)(type);
            return '';
    }
}
function labelTypeListItem(type) {
    return {
        content: (0, LabelType_1.localizeLabelTypeName)(type),
        value: (0, LabelType_1.labelTypeToString)(type),
        testId: getLabelTestId(type) + '-' + (0, LabelType_1.labelTypeToString)(type).toLowerCase(),
    };
}
//# sourceMappingURL=labelValues.js.map